import moment from 'moment-timezone';
import qs from 'qs';
import {
  SALES_CHART_TYPES_REQUEST,
  SALES_CHART_TYPES_FAILURE,
  SALES_CHART_TYPES_SUCCESS,
} from '../constants/actions';
import config from '../../config';
import { getItem, setItem } from '../utils/storage';
import { fetchM } from './fetchM';
import { handleError } from './error';

function salesChartTypesRequest() {
  return {
    type: SALES_CHART_TYPES_REQUEST,
  };
}

function salesChartTypesSuccess(data, token = null) {
  return {
    type: SALES_CHART_TYPES_SUCCESS,
    payload: {
      data,
      token,
    },
  };
}

function salesChartTypesError(message) {
  return {
    type: SALES_CHART_TYPES_FAILURE,
    payload: {
      statusText: message,
    },
  };
}

export function fetchSalesChartTypes(fresh = true) {
  return (dispatch) => {
    let token = null;
    let reload = false;
    dispatch(salesChartTypesRequest());
    if (!fresh) {
      let salesChartTypesData = {};
      try {
        salesChartTypesData = JSON.parse(getItem(`${config.get('appName')}.salesChartTypes`)) || {};
      } catch (e) {
        Bugsnag.notifyException(e);
      }
      if (
        !salesChartTypesData.data ||
        config.get('version') !== salesChartTypesData.version ||
        moment().isAfter(moment(salesChartTypesData.createdAt).add(1, 'day'))
      ) {
        reload = true;
      }
      if (!reload) {
        dispatch(salesChartTypesSuccess(salesChartTypesData.data));
        return Promise.resolve();
      }
    }
    const q = Object.assign({
      limit: 0,
    });
    return dispatch(fetchM(`/sales_chart_types/?${qs.stringify(q)}`, {
      credentials: 'include',
    }))
      .then((res) => {
        token = res.headers.get('X-Csrf-Token');
        return res.json();
      })
      .then((data) => {
        try {
          setItem(`${config.get('appName')}.salesChartTypes`, JSON.stringify({
            data,
            createdAt: moment().toDate(),
            version: config.get('version'),
          }));
        } catch (e) {
          Bugsnag.notifyException(e);
        }
        dispatch(salesChartTypesSuccess(data, token));
      })
      .catch(err => dispatch(handleError(err, salesChartTypesError)));
  };
}



// WEBPACK FOOTER //
// ./src/actions/salesChartTypes.js